'use strict';

exports.__esModule = true;

var _b_ = require('b_');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClassNameBuilder = function () {
    function ClassNameBuilder(options) {
        _classCallCheck(this, ClassNameBuilder);

        this.b_ = (0, _b_.B)(options);
    }

    ClassNameBuilder.prototype.stringify = function stringify(block, elem, mods, mixes, cls) {
        var _this = this;

        return this.b_(block, elem, mods) + (mixes ? ' ' + mixes.map(function (mix) {
            return mix ? _this.b_(mix.block || block, mix.elem, mix.mods) : '';
        }).join(' ') : '') + (cls ? ' ' + cls : '');
    };

    ClassNameBuilder.prototype.joinMixes = function joinMixes(mix1, mix2) {
        if (Array.isArray(mix1)) {
            mix2 = mix1[1];
            mix1 = mix1[0];
        }

        if (!mix1 && !mix2) {
            return;
        }

        var mixes = [];

        mix1 && (mixes = [].concat(mixes, mix1));
        mix2 && (mixes = [].concat(mixes, mix2));

        return mixes;
    };

    return ClassNameBuilder;
}();

exports.default = ClassNameBuilder;